import { render, staticRenderFns } from "./CamposCapitulo.vue?vue&type=template&id=60e0ae7e"
import script from "./CamposCapitulo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CamposCapitulo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports